import React from 'react';
import { Router, Route, IndexRedirect } from 'react-router';

// Routes
import * as routes from './const';

//Mainlayout
import MainLayoutWide from '../../../layouts/MainLayoutWide';

// users admin
import UserListing from '../UserListing';
import UserForm from '../components/UserForm';

import RoleListing from '../RoleListing';
import RoleForm from '../components/RoleForm';
import ContentListing from '../ContentListing';
import ContentForm from '../components/ContentForm';
import { lazyLoadComponent } from '../../../routes/routeUtils';
import UserRestrictions from '../components/UserRestrictions';

const adminReducer = {
  name: 'userAdmin',
  import: () => import('../reducers/index')
};

const AdminRoutes = store => {
  return (
    <Route path={routes.ADMIN} component={MainLayoutWide}>
      <IndexRedirect to={routes.USER_LISTING} />
      <Route
        path={routes.USER_LISTING}
        getComponent={lazyLoadComponent(UserListing, store, adminReducer)}
      />
      <Route
        path={routes.USER_RESTRICTIONS}
        getComponent={lazyLoadComponent(UserRestrictions, store, adminReducer)}
      />
      <Route
        path={routes.USER_FORM}
        getComponent={lazyLoadComponent(UserForm, store, adminReducer)}
      />
      <Route
        path={routes.ROLE_LISTING}
        getComponent={lazyLoadComponent(RoleListing, store, adminReducer)}
      />
      <Route
        path={routes.ROLE_FORM}
        getComponent={lazyLoadComponent(RoleForm, store, adminReducer)}
      />
      <Route
        path={routes.CONTENT_LISTING}
        getComponent={lazyLoadComponent(ContentListing, store, adminReducer)}
      />
      <Route
        path={routes.CONTENT_FORM}
        getComponent={lazyLoadComponent(ContentForm, store, adminReducer)}
      />
      
    </Route>
  );
};

export default AdminRoutes;



// WEBPACK FOOTER //
// ./src/features/users/routes/index.js